    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            shifts: null,
            shiftUpdated: null,
            creatingNewShift: null
        }
    }
    
    const state = getDefaultState()

    const getters = {
        shifts: state => {
            return state.shifts
        },
        shiftUpdated: state => {
            return state.shiftUpdated
        },
        creatingNewShift: state => {
            return state.creatingNewShift
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        shifts: (state, payload) => {
            state.shifts = payload
        },
        shiftUpdated: (state, payload) => {
            state.shiftUpdated = payload
        },
        creatingNewShift: (state, payload) => {
            state.creatingNewShift = payload
        },
    }

    const actions = {
       
        getShifts: ({commit, dispatch}, payload) =>{
            commit('updating', true)
            axiosAuth.get('/shifts/' + payload._id )
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    commit('shifts', res.data)
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                    if(error.response){
                        if(error.response.status == 401) dispatch('logout')
                    }
                }
              )
        },

        getMyShifts: ({commit, dispatch}) =>{
            commit('updating', true)
            axiosAuth.get('users/myshifts')
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                    if(error.response){
                        if(error.response.status == 401) dispatch('logout')
                    }
                }
              )
        },

        postShift ({commit, dispatch}, payload) {
            commit('updating', true)
            commit('creatingNewShift', true)
            axiosAuth.post('/shifts', payload.data)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        
                        //dispatch('getshifts')
                        dispatch('getCompany')
                    }
                )
                .catch(
                error => {
                    console.log(error)
                    commit('updating', false)
                    
                }
                )
        },

        deleteShift: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.delete('/shifts/'+ payload._id, payload.data)
            .then(
                () => {
                    dispatch('getCompany')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        updateShift: ({commit}, payload) => {
            commit('updating', true)
            axiosAuth.patch('/shifts/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)

                    // dispatch('getCompany')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        }
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }